import { render } from "./CarouselList.vue?vue&type=template&id=fbbd228e&scoped=true&ts=true"
import script from "./CarouselList.ts?vue&type=script&lang=ts"
export * from "./CarouselList.ts?vue&type=script&lang=ts"

import "./CarouselList.scss?vue&type=style&index=0&id=fbbd228e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbbd228e"]])

export default __exports__